import React from 'react';
import { Shield } from 'lucide-react';
import { Badge } from '../components/Badge';
export function Privacy() {
  const sections = [{
    title: '1. Information We Collect',
    body: 'We collect information you provide directly to us, including your name, email address, company information, and any business data you upload to Akios BOS. We also automatically collect certain technical information when you use our services, such as IP address, browser type, and usage patterns.'
  }, {
    title: '2. How We Use Your Information',
    body: 'We use your information to provide, maintain, and improve Akios BOS, to communicate with you about your account, to send service announcements, and to provide customer support. We never sell your data to third parties.'
  }, {
    title: '3. Data Storage & Security',
    body: 'Your data is encrypted in transit and at rest using industry-standard protocols. We host customer data in secure cloud infrastructure with strict access controls, regular security audits, and SOC 2 aligned practices.'
  }, {
    title: '4. Data Sharing',
    body: 'We do not sell or rent your personal information. We may share information with trusted service providers who help us operate Akios BOS, and only under strict confidentiality agreements. We may also disclose information if required by law.'
  }, {
    title: '5. Your Rights',
    body: 'You have the right to access, correct, or delete your personal information at any time. You can also request data portability or restrict certain processing. Contact us at akiosventure@gmail.com to exercise these rights.'
  }, {
    title: '6. Cookies',
    body: 'We use cookies and similar technologies to keep you signed in, remember preferences, and understand how Akios BOS is used. You can control cookies through your browser settings.'
  }, {
    title: '7. Changes to This Policy',
    body: 'We may update this Privacy Policy from time to time. We will notify you of material changes via email or through Akios BOS before the changes take effect.'
  }, {
    title: '8. Contact Us',
    body: 'For any privacy questions or concerns, reach us at akiosventure@gmail.com or write to Akios Edge Pvt. Ltd., Chennai, Tamil Nadu, India.'
  }];
  return <div className="w-full" data-id="element-539">
      <section className="pt-20 pb-12 bg-gradient-to-b from-white via-slate-50 to-indigo-50/40" data-id="element-540">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-541">
          <Badge icon={<Shield className="w-3.5 h-3.5" data-id="element-543" />} text="PRIVACY POLICY" data-id="element-542" />
          <h1 className="text-4xl md:text-5xl font-black leading-tight tracking-tight mb-4 text-[#0B1020]" data-id="element-544">
            Your Privacy <span className="text-brand-blue" data-id="element-545">Matters</span>
          </h1>
          <p className="text-slate-600" data-id="element-546">Last updated: May 1, 2026</p>
        </div>
      </section>

      <section className="py-16 bg-white" data-id="element-547">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose-slate" data-id="element-548">
          <p className="text-slate-600 leading-relaxed mb-10" data-id="element-549">
            This Privacy Policy describes how Akios Edge Pvt. Ltd. ("we", "us",
            "our") collects, uses, and protects information when you use Akios
            BOS and our related services.
          </p>
          <div className="space-y-8" data-id="element-550">
            {sections.map(s => <div key={s.title} data-id="element-551">
                <h2 className="text-xl font-bold text-slate-900 mb-3" data-id="element-552">
                  {s.title}
                </h2>
                <p className="text-slate-600 leading-relaxed" data-id="element-553">{s.body}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}